var swiperInstance;
function enableSwiper() {
    var wrapper = document.querySelector('.gallery-wrapper');
    if (window.innerWidth <= 1024 && !swiperInstance) {
        wrapper.classList.add('swiper');
        wrapper.innerHTML = '<div class="swiper-wrapper">' + Array.from(wrapper.children).map(function(el) {
            return '<div class="swiper-slide">'.concat(el.innerHTML, "</div>");
        }).join('') + '</div>' + '<div class="swiper-pagination"></div>';
        swiperInstance = new Swiper('.gallery-wrapper', {
            loop: false,
            spaceBetween: 10,
            centeredSlides: true,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                    centeredSlides: false
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 32
                }
            }
        });
    } else if (window.innerWidth > 1024 && swiperInstance) {
        var slides = document.querySelectorAll('.swiper-slide');
        var wrapperHTML = Array.from(slides).map(function(slide) {
            return '<div class="gallery-item">'.concat(slide.innerHTML, "</div>");
        }).join('');
        wrapper.innerHTML = wrapperHTML;
        wrapper.classList.remove('swiper');
        swiperInstance.destroy(true, true);
        swiperInstance = undefined;
    }
}
window.addEventListener('load', enableSwiper);
window.addEventListener('resize', enableSwiper);

//# sourceMappingURL=Museum.979fb8fc.js.map
